export default class NetworkError extends Error {
  constructor(message?: string) {
    super(`ネットワークを確認してください。${message ? `(${message})` : ''}`)
    this.name = '通信エラー'
  }
}
